<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-4" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/realisasi-abo')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/end-present')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">REALISASI CAPEX YTD {{ this.options.months.find(d=> d.value==this.month).name.toUpperCase() }} {{ this.year }}</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.chart" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                <div v-html="lastUpdate"></div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row mt-0 mb-0">
                    <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-4' : 'col-md-6' ) + ' '">
                        <LineChart v-loading.body="loading.chart" :data="chartdatacapex1" :width="500" :height="350" style="margin-top:20px;"/>
                    </div>

                    <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-4' : 'col-md-6' ) + ' '">
                        <LineChart v-loading.body="loading.chart2" :data="chartdatacapex2" :width="500" :height="350" style="margin-top:20px;"/>
                    </div>

                    <div class="col-md-4" v-if="String(this.description || '').trim().length > minLengthDescription">
                        <h6 class="text-center">HIGHLIGHT</h6>
                        <div class="p-2">
                            <div v-html="description"></div>
                            <!--
                            <ul>
                                <li class="text-justify">Realisasi Finansial ABI BD & Non BD Ytd Mei 2023 sebesar Rp 7,56 Miliar atau 5,70% terhadap target Finansial RKAP 2023 sebesar Rp 132,65 Milyar</li>
                                <li class="text-justify">Realisasi progress fisik ABI BD & NBD  Ytd Mei 2023 sebesar Rp. 22,74 Miliar atau 107% dari target fisik ABI BD & NBD Ytd Mei 2023 sebesar Rp 21 Milyar</li>
                            </ul>
                            -->
                            <Loader v-if="loading.description"/>
                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-4">
                        <div class="text-center chart-title">Realisasi Finance</div>
                        <BarChart v-loading.body="loading.chart3" :data="chartdatacapexrealisasi" :width="500" :height="320"/>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        LineChart,
        BarChart,
        Loader,
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,
            chartdata: [],
            loading: {
                table: false,
                chart: false,
                chart2: false,
                chart3: false,
                description: false,
            },
            
            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,
            
            description : '',

            chartdatacapex1: [],
            chartdatacapex2: [],
            chartdatacapexrealisasi: [],

            //sample
            chartdata1:[
                {
                    label: 'Jan 2023',
                    legend: 'Plan Finance (BD)',
                    valuecol: 0,
                },
                {
                    label: 'Jan 2023',
                    legend: 'Plan Fisik BD',
                    valuecol: 19,
                },
                {
                    label: 'Jan 2023',
                    legend: 'Real Fisik BD',
                    valuecol: 207,
                },
                {
                    label: 'Jan 2023',
                    legend: 'Realisasi Finance (BD)',
                    valuecol: 0.41,
                },

                //FEB
                {
                    label: 'Feb 2023',
                    legend: 'Plan Finance (BD)',
                    valuecol: 1,
                },
                {
                    label: 'Feb 2023',
                    legend: 'Plan Fisik BD',
                    valuecol: 19,
                },
                {
                    label: 'Feb 2023',
                    legend: 'Real Fisik BD',
                    valuecol: 207,
                },
                {
                    label: 'Feb 2023',
                    legend: 'Realisasi Finance (BD)',
                    valuecol: 1.20,
                },

                //MAR
                {
                    label: 'Mar 2023',
                    legend: 'Plan Finance (BD)',
                    valuecol: 1,
                },
                {
                    label: 'Mar 2023',
                    legend: 'Plan Fisik BD',
                    valuecol: 19,
                },
                {
                    label: 'Mar 2023',
                    legend: 'Real Fisik BD',
                    valuecol: 208,
                },
                {
                    label: 'Mar 2023',
                    legend: 'Realisasi Finance (BD)',
                    valuecol: 4.5,
                },

                //APR
                {
                    label: 'Apr 2023',
                    legend: 'Plan Finance (BD)',
                    valuecol: 1,
                },
                {
                    label: 'Apr 2023',
                    legend: 'Plan Fisik BD',
                    valuecol: 19,
                },
                {
                    label: 'Apr 2023',
                    legend: 'Real Fisik BD',
                    valuecol: 208,
                },
                {
                    label: 'Apr 2023',
                    legend: 'Realisasi Finance (BD)',
                    valuecol: 5.3,
                },

                //MEI
                {
                    label: 'Mei 2023',
                    legend: 'Plan Finance (BD)',
                    valuecol: 14,
                },
                {
                    label: 'Mei 2023',
                    legend: 'Plan Fisik BD',
                    valuecol: 21,
                },
                {
                    label: 'Mei 2023',
                    legend: 'Real Fisik BD',
                    valuecol: 208,
                },
                {
                    label: 'Mei 2023',
                    legend: 'Realisasi Finance (BD)',
                    valuecol: 7.6,
                },


            ],

            chartdata2:[
                {
                    label: 'Jan 2023',
                    legend: 'Plan Finance (NBD)',
                    valuecol:  0,
                },
                {
                    label: 'Jan 2023',
                    legend: 'Realisasi Finance (NBD)',
                    valuecol: 0.29,
                },

                //FEB
                {
                    label: 'Feb 2023',
                    legend: 'Plan Finance (NBD)',
                    valuecol:  1,
                },
                {
                    label: 'Feb 2023',
                    legend: 'Realisasi Finance (NBD)',
                    valuecol: 1.09,
                },

                //MAR
                {
                    label: 'Mar 2023',
                    legend: 'Plan Finance (NBD)',
                    valuecol:  1,
                },
                {
                    label: 'Mar 2023',
                    legend: 'Realisasi Finance (NBD)',
                    valuecol: 3,
                },

                //APR
                {
                    label: 'Apr 2023',
                    legend: 'Plan Finance (NBD)',
                    valuecol:  1,
                },
                {
                    label: 'Apr 2023',
                    legend: 'Realisasi Finance (NBD)',
                    valuecol: 3.43,
                },

                //MEI
                {
                    label: 'Mei 2023',
                    legend: 'Plan Finance (NBD)',
                    valuecol:  12,
                },
                {
                    label: 'Mei 2023',
                    legend: 'Realisasi Finance (NBD)',
                    valuecol: 4.77,
                },

            ],

            chartdata3: [
                {
                    label: 'RKAP 2023',
                    legend: 'BD',
                    valuecol: 55.535,
                },
                {
                    label: 'RKAP 2023',
                    legend: 'NON BD',
                    valuecol: 77.115,
                },

                {
                    label: 'Real Ytd Mei 2023',
                    legend: 'BD',
                    valuecol: 4.772,
                },
                {
                    label: 'Real Ytd Mei 2023',
                    legend: 'NON BD',
                    valuecol: 7.551,
                },
                
            ],
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        //this.setChart()
        this.setDefaultPeriod()
        this.getResmueBDChart()
        this.getResumeNBDChart()
        this.getRealisasiFinanceChart()
        this.getDescription()
    },
    methods: {
        setChart() {
            //sample
            this.chartdatacapex1 = this.processBarChart(this.chartdata1, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatacapex2 = this.processBarChart(this.chartdata2, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatacapexrealisasi = this.processBarChart(this.chartdata3, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, true);
        },

        getResmueBDChart() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/chart-capex-resume-bd?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.chart = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let reportData = response.data;
                this.chartdata1 = reportData.data

                this.chartdatacapex1 = this.processBarChart(this.chartdata1, "label", "", "Value", false, "legend", "", 1, 2, this.colors, false, false, false, false);
                this.lastUpdate = reportData.last_update
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.chart = false;
			})     

        },

        getResumeNBDChart() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/chart-capex-resume-nbd?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.chart2 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let reportData = response.data;
                this.chartdata2 = reportData.data

                this.chartdatacapex2 = this.processBarChart(this.chartdata2, "label", "", "Value", false, "legend", "", 1, 2, this.colors, false, false, false, false);
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.chart2 = false;
			})     

        },

        getRealisasiFinanceChart() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/chart-capex-realisasi-finance?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.chart3 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let reportData = response.data;
                this.chartdata3 = reportData.data

                this.chartdatacapexrealisasi = this.processBarChart(this.chartdata3, "label", "", "value", false, "legend", "", 1, 2, this.colors, false, false, false, true);
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.chart3 = false;
			})     

        },

        getDescription() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/capex-description?'
            
            this.urlRequestParams+='year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.description = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.description = response.data.data.description;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.description = false;
			})     

        },

        applyFilter() {
            this.getResmueBDChart()
            this.getResumeNBDChart()
            this.getRealisasiFinanceChart()
            this.getDescription()
        },
    },
}
</script>

<style scoped>
.chart-title {
    background:#5B9BD5;
    color:#000;
    padding:2px;
}
</style>